import './child-image.scss';

import { Either } from '@sola/schema/dotcom/helpers.js';

import { cn } from '../../utils/helpers';

// TODO: Jeff Boutwell changed this last week - but it throws an error because no width is specified...
// import { Image } from '../image/image';

const transformTemplate = '/w_150/';
const defaultWidth = 100;

export enum ChildImageVariantEnum {
  Full = 'full',
  Portrait = 'portrait',
  Thumb = 'thumb',
  Circle = 'circle',
}

const imageTransforms: {
  [variant in ChildImageVariantEnum]: {
    transform: string;
  };
} = {
  [ChildImageVariantEnum.Full]: {
    transform: '/f_auto,q_auto/',
  },
  [ChildImageVariantEnum.Portrait]: {
    transform: '/t_portrait/f_auto,q_auto/',
  },
  [ChildImageVariantEnum.Thumb]: {
    transform: '/t_thumb/f_auto,q_auto/',
  },
  [ChildImageVariantEnum.Circle]: {
    transform: '/t_thumb/f_auto,q_auto/',
  },
};

const getChildImageUrl = (
  childImageUrl: string,
  variant: ChildImageVariantEnum,
  width = defaultWidth,
) => {
  if (!childImageUrl || !childImageUrl.includes(transformTemplate)) {
    return null;
  }
  return childImageUrl.replace(
    transformTemplate,
    `${imageTransforms[variant].transform}w_${width}/`,
  );
};

export type ChildImageProps = {
  variant?: ChildImageVariantEnum;
  // could receive a child object instead...?
  childImageUrl?: string;
  width?: number;
  // height?: number; // height would be conditional I'd expect
  className?: string;
} & Either<{ name: string }, { alt: string }>;

export const ChildImage: React.FC<ChildImageProps> = ({
  alt,
  childImageUrl,
  name,
  variant = ChildImageVariantEnum.Full,
  width = defaultWidth,
  // height,
  className,
}) => {
  const imageUrl = getChildImageUrl(childImageUrl || '', variant, width);
  if (!imageUrl) {
    return null;
  }

  return (
    <img
      className={cn(`ChildImage`, className, {
        'ChildImage--circle': variant === ChildImageVariantEnum.Circle,
      })}
      src={imageUrl}
      // @TODO: Translate string.
      alt={alt || `Photo of ${name}`}
      width={width}
      crossOrigin="anonymous"
    />
  );
};
